import { render, staticRenderFns } from "./commentManagement.vue?vue&type=template&id=53a17dbc&scoped=true&"
import script from "./commentManagement.vue?vue&type=script&lang=js&"
export * from "./commentManagement.vue?vue&type=script&lang=js&"
import style0 from "./commentManagement.vue?vue&type=style&index=0&id=53a17dbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a17dbc",
  null
  
)

export default component.exports